import { getImageUrl } from "@hooks/utils/useUpload";
import {
  ContractorReport,
  ContractorReportLineItem,
  ReportStatus,
} from "@interfaces/contractorReport";

export const decodeReport = async (
  report: ContractorReport
): Promise<ContractorReportLineItem> => {
  const presignedUrl =
    report.organisation_logo.length > 0
      ? await getImageUrl(report.organisation_logo)
      : "";
  return {
    id: report.contractor_report_id,
    contractorId: report.contractor_id,
    contractorPackageId: report.contractor_package_id,
    organisationName: report.organisation_name,
    organisationLogo: presignedUrl,
    dueDateMonth: report.due_date_month,
    dueDateYear: report.due_date_year,
    created: new Date(report.created),
    status: decodeReportStatus(report.status),
  };
};

export const encodeReport = (
  report: ContractorReportLineItem
): ContractorReport => {
  return {
    contractor_report_id: report.id,
    contractor_id: report.contractorId,
    contractor_package_id: report.contractorPackageId,
    organisation_name: report.organisationName,
    organisation_logo: report.organisationLogo,
    due_date_month: report.dueDateMonth,
    due_date_year: report.dueDateYear,
    created: report.created,
    status: encodeReportStatus(report.status),
  };
};

export const decodeReportStatus = (reportStatus: string): ReportStatus => {
  switch (reportStatus) {
    default:
    case "report-status_upcoming":
      return ReportStatus.Upcoming;
    case "report-status_overdue":
      return ReportStatus.Overdue;
    case "report-status_in-progress":
      return ReportStatus.InProgress;
    case "report-status_complete":
      return ReportStatus.Complete;
  }
};

const encodeReportStatus = (reportStatus: ReportStatus): string => {
  switch (reportStatus) {
    case ReportStatus.Upcoming:
      return "report-status_upcoming";
    case ReportStatus.InProgress:
      return "report-status_in-progress";
    case ReportStatus.Complete:
      return "report-status_complete";
    case ReportStatus.Overdue:
      return "report-status_overdue";
  }
};
